import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sms-dashboard-new',
  templateUrl: './sms-dashboard-new.component.html',
  styleUrls: ['./sms-dashboard-new.component.scss'],
})
export class SmsDashboardNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
